import type { Translate } from '~/shared/internationalization/translation';

export type FeedbackDialogLabelsStoreState = {
    readonly cancelButtonLabel: string;
    readonly changeSkillLanguageLabel: string;
    readonly changeSkillReasonLabel: string;
    readonly changeSkillReasonPlaceholderLabel: string;
    readonly createSkillDescriptionLabel: string;
    readonly createSkillPlaceholderLabel: string;
    readonly createSkillSkillTypeLabel: string;
    readonly createSkillTitleLabel: string;
    readonly feedbackDescriptionLabel: string;
    readonly hardSkillLabel: string;
    readonly languageSkillLabel: string;
    readonly provideFeedbackDescriptionLabel: string;
    readonly provideFeedbackTitleLabel: string;
    readonly reportContentIssueLabel: string;
    readonly reportSkillLabel: string;
    readonly reportSkillReasonLabel: string;
    readonly reportSkillReasonPlaceholderLabel: string;
    readonly requestNewSkillLabel: string;
    readonly requestNewSkillTitlePlaceholderLabel: string;
    readonly searchSkillsToAddPlaceholderLabel: string;
    readonly sendFeedbackErrorLabel: string;
    readonly skillContentReportSuccessMessageLabel: string;
    readonly skillContentReportSuccessTitleLabel: string;
    readonly skillReportSuccessMessageLabel: string;
    readonly skillReportSuccessTitleLabel: string;
    readonly skillRequestSuccessMessageLabel: string;
    readonly skillRequestSuccessTitleLabel: string;
    readonly softSkillLabel: string;
    readonly submitFeedbackLabel: string;
};

export const createTranslatedFeedbackDialogLabels = (translate: Translate): (() => FeedbackDialogLabelsStoreState) => {
    return () => ({
        cancelButtonLabel: translate('common.cancel'),
        changeSkillLanguageLabel: translate('pages.feedback.change-skill-language'),
        changeSkillReasonLabel: translate('pages.feedback.change-skill-reason'),
        changeSkillReasonPlaceholderLabel: translate('pages.feedback.change-skill-reason-placeholder'),
        createSkillDescriptionLabel: translate('common.description'),
        createSkillPlaceholderLabel: translate('pages.feedback.create-skill-placeholder'),
        createSkillSkillTypeLabel: translate('pages.feedback.create-skill-skill-type'),
        createSkillTitleLabel: translate('common.skill'),
        feedbackDescriptionLabel: translate('pages.feedback.feedback-description'),
        hardSkillLabel: translate('common.enums.skillType.hard'),
        languageSkillLabel: translate('common.enums.skillType.language'),
        provideFeedbackDescriptionLabel: translate('pages.feedback.provide-feedback-description'),
        provideFeedbackTitleLabel: translate('pages.feedback.provide-feedback-title'),
        reportContentIssueLabel: translate('pages.feedback.report-content-issue'),
        reportSkillLabel: translate('pages.feedback.report-skill'),
        reportSkillReasonLabel: translate('pages.feedback.report-skill-reason'),
        reportSkillReasonPlaceholderLabel: translate('pages.feedback.report-skill-reason-placeholder'),
        requestNewSkillLabel: translate('pages.feedback.request-new-skill'),
        requestNewSkillTitlePlaceholderLabel: translate('pages.feedback.request-new-skill-title-placeholder'),
        searchSkillsToAddPlaceholderLabel: translate(
            'pages.job-architecture.job-profile-skill-search-placeholder-label',
        ),
        sendFeedbackErrorLabel: translate('pages.feedback.send-error'),
        skillContentReportSuccessMessageLabel: translate('pages.feedback.skill-content-report-success-message'),
        skillContentReportSuccessTitleLabel: translate('pages.feedback.skill-content-report-success-title'),
        skillReportSuccessMessageLabel: translate('pages.feedback.skill-report-success-message'),
        skillReportSuccessTitleLabel: translate('pages.feedback.skill-report-success-title'),
        skillRequestSuccessMessageLabel: translate('pages.feedback.skill-request-success-message'),
        skillRequestSuccessTitleLabel: translate('pages.feedback.skill-request-success-title'),
        softSkillLabel: translate('common.enums.skillType.soft'),
        submitFeedbackLabel: translate('pages.feedback.submit-feedback'),
    });
};
